import spCloverSvg from '@/assets/events/saint-patrick/clover.svg';
import spGoldenSnitchSvg from '@/assets/events/saint-patrick/golden-snitch.svg';
import spLogoFullSvg from '@/assets/events/saint-patrick/logo-full.svg';
import type { BonusMultiplierCombinationStrategy, CampaignBonusNft, CampaignPromoButtonConfig } from './campaign-config';

type SaintPatrickEventState = 'disabled' | 'live';

interface SaintPatrickArtworkConfig {
	buttonIcon: string;
	buttonAccent: string;
	logoFull: string;
}

interface SaintPatrickQualificationConfig {
	questKey: string;
	requiredWins: number;
	minStakeSui: number;
	playLink: string;
}

interface SaintPatrickPrizeConfig {
	draw: number[];
	streakLeader: number;
}

interface SaintPatrickTicketingConfig {
	apiPath: string;
	wageringCoinSymbol: string;
	additionalTicketStep: number;
	baseMultiplier: number;
	bonusNfts: CampaignBonusNft[];
	bonusCombinationStrategy: BonusMultiplierCombinationStrategy;
}

export interface SaintPatrickEventConfig {
	id: string;
	slug: string;
	name: string;
	state: SaintPatrickEventState;
	timeframe: {
		start: string;
		end: string;
		displayEnd: string;
	};
	qualification: SaintPatrickQualificationConfig;
	ticketing: SaintPatrickTicketingConfig;
	prizes: SaintPatrickPrizeConfig;
	promoButton?: CampaignPromoButtonConfig;
	artwork: SaintPatrickArtworkConfig;
}

const SAINT_PATRICK_TIMEFRAME = {
	start: '2026-03-14T00:00:00.000Z',
	end: '2026-03-19T00:00:00.000Z',
	displayEnd: '2026-03-18T00:00:00.000Z',
};

function resolveSaintPatrickEventState(now: Date = new Date()): SaintPatrickEventState {
	const start = new Date(SAINT_PATRICK_TIMEFRAME.start);
	const end = new Date(SAINT_PATRICK_TIMEFRAME.end);
	return now >= start && now < end ? 'live' : 'disabled';
}

const SAINT_PATRICK_PROMO_BUTTON: CampaignPromoButtonConfig = {
	id: 'sidebar.saint-patrick-welcome',
	label: '$150 to win!',
};

const SAINT_PATRICK_STATE = resolveSaintPatrickEventState();

export const SAINT_PATRICK_EVENT_CFG: SaintPatrickEventConfig = {
	id: 'saint-patrick-lucky-streak',
	slug: 'saint-patrick',
	name: "Saint Patrick's Lucky Streak",
	state: SAINT_PATRICK_STATE,
	timeframe: SAINT_PATRICK_TIMEFRAME,
	qualification: {
		questKey: 'coinflip_win_streak_3',
		requiredWins: 3,
		minStakeSui: 1,
		playLink: '/coinflip',
	},
	ticketing: {
		apiPath: '/campaigns/saint-patrick/tickets',
		wageringCoinSymbol: 'SUI',
		additionalTicketStep: 10,
		baseMultiplier: 1,
		bonusCombinationStrategy: 'multiply',
		bonusNfts: [
			{
				nameIncludes: 'Cane',
				multiplier: 2,
			},
			{
				nameIncludes: 'Slush',
				multiplier: 1.5,
			},
		],
	},
	prizes: {
		draw: [50, 20, 20, 10, 10, 10, 10],
		streakLeader: 20,
	},
	promoButton: SAINT_PATRICK_STATE === 'live' ? SAINT_PATRICK_PROMO_BUTTON : undefined,
	artwork: {
		buttonIcon: spCloverSvg,
		buttonAccent: spGoldenSnitchSvg,
		logoFull: spLogoFullSvg,
	},
};
